<template>
    <modal id="get-a-quote" centered hide-footer>
        <template #title>
            <b-row class="text-center" align-h="center">
                <b-avatar variant size="4rem" class="avatar"><span class="text-primary avatar-text">CS</span></b-avatar>
            </b-row>
        </template>
        <h2 class="text-primary text-center">{{ title }}</h2>
        <p class="description">{{ description }}</p>
        <primary-btn class="w-100" :loading="continueBtn.loading" @click.native="gotoLibertyMutual">
            {{ continueBtn.text }}
        </primary-btn>
    </modal>
</template>

<script>
import Modal from "Components/Modal";
import PrimaryBtn from "Components/Buttons/PrimaryBtn";

export default {
    name: "GetAQuote",

    components: { PrimaryBtn, Modal },
    data() {
        return {
            continueBtn: {
                text: "Continue",
                loading: false,
            },
            title: "You are leaving CarSaver.com!",
            description: `You will be redirected to Liberty Mutual. CarSaver is not responsible for any content,
            terms or conditions on this third-party website.`,
        };
    },
    methods: {
        gotoLibertyMutual() {
            this.timedLoader();

            window.open(
                "https://www.libertymutual.com/multi-online-quotes?selectedOpt=auto&?src=aff_4cb_m_0135094_carsaver&MM_webID=0000023999",
                "Liberty Mutual",
                "noopener"
            );
        },
        timedLoader() {
            const loadingTimeout = 3000;
            this.continueBtn.loading = true;

            setTimeout(() => {
                this.continueBtn.loading = false;
            }, loadingTimeout);
        },
    },
};
</script>

<style lang="scss" scoped>
.avatar {
    border-radius: 50%;
    border: 1px solid #d3d3d3;
}
.avatar-text {
    font-size: px2rem(32);
    font-weight: bold;
}
.description {
    margin: px2rem(0);
    padding-right: px2rem(10);
    padding-left: px2rem(10);
    text-align: center;
    padding-bottom: px2rem(20);
}
</style>
